// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OH4Sr","tabsBox":"styles_tabsBox__2XE1b","createButton":"styles_createButton__1NM1v"};